import React from 'react';
import { ShieldCheckIcon, CreditCardIcon, LandmarkIcon, ClockIcon, LockIcon } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-[#03101f] pt-16 pb-8 border-t border-dark-border" data-id="element-64">
      <div className="max-w-6xl mx-auto px-4" data-id="element-65">
        <div className="flex flex-wrap justify-center gap-6 md:gap-12 text-sm text-cyan-100/80 font-medium mb-16 border-b border-dark-border/50 pb-12" data-id="element-66">
          <span className="flex items-center gap-2" data-id="element-67">
            <LockIcon size={18} className="text-primary" data-id="element-68" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-69">
            <ClockIcon size={18} className="text-primary" data-id="element-70" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-71">
            <ShieldCheckIcon size={18} className="text-primary" data-id="element-72" /> Garantía 7
            días
          </span>
          <span className="flex items-center gap-2" data-id="element-73">
            <LandmarkIcon size={18} className="text-primary" data-id="element-74" /> Mercado Pago
          </span>
          <span className="flex items-center gap-2" data-id="element-75">
            <CreditCardIcon size={18} className="text-primary" data-id="element-76" /> Transferencia
            bancaria
          </span>
        </div>

        <div className="text-center mb-12" data-id="element-77">
          <h3 className="text-2xl font-black text-white mb-4" data-id="element-78">
            🤖 SUPERKIT IA™
          </h3>
          <p className="text-cyan-100/80 mb-2" data-id="element-79">
            El sistema N°1 de productividad con IA para profesionales y
            emprendedores en Argentina.
          </p>
          <p className="text-cyan-200/60 italic" data-id="element-80">
            Porque trabajar más horas no es la solución. Tener el sistema
            correcto sí lo es.
          </p>
        </div>

        <div className="text-center text-xs text-cyan-200/40" data-id="element-81">
          <p className="mb-4" data-id="element-82">
            © SUPERKIT IA™ 2026 — Todos los derechos reservados. Prohibida la
            reproducción y redistribución sin autorización expresa.
          </p>
          <p className="text-primary font-medium italic text-sm" data-id="element-83">
            "La próxima semana puede ser la primera en que la IA trabaja para
            vos, no al revés." 🤖
          </p>
        </div>
      </div>
    </footer>;
};